import { render, staticRenderFns } from "./SystemMessages.vue?vue&type=template&id=2045d958&scoped=true&"
import script from "./SystemMessages.vue?vue&type=script&lang=js&"
export * from "./SystemMessages.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessages.vue?vue&type=style&index=0&id=2045d958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045d958",
  null
  
)

export default component.exports